export default function ListWebsiteYouLike({ register, errors }) {
  const fieldName = "listwesbsiteyoulike";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Websites you like (up to 5) and why
      </label>
      <textarea
        id={fieldName}
        className="wdc-field"
        rows="4"
        placeholder="e.g. example.com — love the clean layout and typography"
        {...register(fieldName, { required: true })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
